module.exports = __webpack_public_path__ + "img/39.b882773a.png";